// Une fois que la page est chargée
window.addEventListener("DOMContentLoaded", () => {

  initReassuranceCarousel();
  initURLTarget();

  // Page produit
  // Fermeture Guide des tailles
  $(document).on('click', '.pop .close, .pop', function () {
    $("body").removeClass("overflow-hidden");
    $(".pop").fadeOut();
    $(".pop_content").removeClass("active");
  });

  $(document).on('click', '.pop_content', function (event) {
    event.stopPropagation();
  });

  // Ouverture Guide des tailles
  $(document).on('click', '.sizing_button', function () {
    $("body").addClass("overflow-hidden");
    $("#sizing").fadeIn();
    $("#sizing_content").addClass("active");
  });

  // Mise à jour de la date de livraison
  if ($(".estimated_delivery span").length) {
    adjust_delivery_time();
  }

  // si on modifie le select de class .cordon_associe (et qu'il existe), on met à jour la value du champ caché de classe ".cordon_id" en y mettant la valeur de l'option sélectionnée
  if ($("#cordon_associe").length) {
    $("#cordon_associe").change(function () {
      console.log("change");
      var selected_option = $(this).find('option:selected');
      console.log(selected_option);
      var cordon_id = selected_option.val();
      $(".cordon_id").val(cordon_id);
    });
  }

  // cart
  // Affichage du pannel commande cadeau
  openGiftMessageArea();

});

function adjust_delivery_time() {
  // Détecte la langue du html
  var lang = $('html').attr('lang');

  var delivery_time = 72; // Nombre moyen d'heures pour être livré
  var now = new Date();
  var delivery_date = new Date();

  // Si on est le vendredi après 12h
  if (delivery_date.getDay() == 5 && delivery_date.getHours() >= 12) {
    delivery_date = delivery_date.addHours(24);
  }

  // Si on est un samedi ou dimanche, on repousse au lundi suivant
  if (now.getDay() == 6 || now.getDay() == 0) {
    var nb_weekend_day = delivery_date.getDay() == 6 ? 2 : 1;
    delivery_date = delivery_date.addHours(nb_weekend_day * 24);
  }

  delivery_date = delivery_date.addHours(delivery_time); // Jour de livraison supposé, hors jour chômés

  // Si on tombe sur une date de livraison un dimanche, on ajoute 24h.
  if (delivery_date.getDay() == 0) {
    delivery_date = delivery_date.addHours(24);
  }

  // Affichage
  var numero_jour_livraison = delivery_date.getDate();

  if (lang == "fr") {
    var nom_jour_livraison = delivery_date.toLocaleDateString("fr-FR", { weekday: 'long' });
    var nom_mois_livraison = delivery_date.toLocaleDateString("fr-FR", { month: 'long' });
    $(".estimated_delivery span").html(nom_jour_livraison + " " + numero_jour_livraison + " " + nom_mois_livraison);
  }
  else {
    var nom_jour_livraison = delivery_date.toLocaleDateString("en-US", { weekday: 'long' });
    var nom_mois_livraison = delivery_date.toLocaleDateString("en-US", { month: 'long' });
    numero_jour_livraison += getDaySuffix(delivery_date.getDate());
    $(".estimated_delivery span").html(nom_jour_livraison + " " + nom_mois_livraison + " " + numero_jour_livraison);
  }

  $(".estimated_delivery").fadeIn();
}

// Ajoute h Heures à une date existante
Date.prototype.addHours = function (h) {
  this.setTime(this.getTime() + (h * 60 * 60 * 1000));
  return this;
}

function getDaySuffix(day) {
  if (day > 3 && day < 21) return 'th';
  switch (day % 10) {
    case 1: return "st";
    case 2: return "nd";
    case 3: return "rd";
    default: return "th";
  }
}

function openGiftMessageArea() {
  $("#is_gift").click(function () {
    if ($(this).is(':checked') == true) {
      $('#message_box').fadeIn(100);
    } else {
      $('#message_box').fadeOut(100);
    }
  });
}

function initReassuranceCarousel() {
  $('.reassurance_pdp').each(function () {
    const $container = $(this);
    const $slider = $container.find('.reassurance_pdp__slider');
    const $slides = $slider.find('.reassurance_pdp__slide');
    const $indicators = $container.find('.reassurance_pdp__indicator');

    // Vérifier s'il y a plus d'une slide
    if ($slides.length <= 1) {
      return;
    }

    let currentSlide = 0;
    let autoPlayInterval = null;

    // Fonction pour changer de slide
    function goToSlide(index) {

      // Masquer toutes les slides
      $slides.hide();

      // Afficher la slide sélectionnée
      $slides.eq(index).show();

      // Mettre à jour les indicateurs
      $indicators.removeClass('reassurance_pdp__indicator--active');
      $indicators.eq(index).addClass('reassurance_pdp__indicator--active');

      currentSlide = index;
    }

    // Fonction pour passer à la slide suivante
    function nextSlide() {
      const nextIndex = (currentSlide + 1) % $slides.length;
      goToSlide(nextIndex);
    }

    // Fonction pour démarrer le défilement automatique
    function startAutoPlay() {
      // S'assurer qu'aucun intervalle n'est déjà en cours
      stopAutoPlay();
      autoPlayInterval = setInterval(nextSlide, 3000); // 3 secondes
    }

    // Fonction pour arrêter le défilement automatique
    function stopAutoPlay() {
      if (autoPlayInterval !== null) {
        clearInterval(autoPlayInterval);
        autoPlayInterval = null;
      }
    }

    // Gestion des clics sur les indicateurs
    $indicators.on('click', function () {
      const slideIndex = $(this).data('slide');
      goToSlide(slideIndex);

      // Redémarrer le défilement automatique après un clic manuel
      // Cela réinitialise le timer à 3 secondes à partir du clic
      stopAutoPlay();
      startAutoPlay();
    });

    // Pause du défilement automatique au survol
    $container.on('mouseenter', stopAutoPlay);
    $container.on('mouseleave', startAutoPlay);

    // Démarrer le défilement automatique
    startAutoPlay();
  });
}

function initURLTarget() {
  $("[data-url_target]").click(function () {
    var url = $(this).data("url_target");
    if (url && url !== "#") {
      $(this).css("cursor", "pointer")
      window.location.href = url;
    }
  });
}


// Product card swiper
class ProductCardSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeSwiper();
  }

  initializeSwiper() {
    new Swiper(this.querySelector(".swiper"), {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
        enabled: false,
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
      // Pour la version non mobile, on n'affiche pas la pagination
      breakpoints: {
        768: {
          pagination: {
            enabled: false,
          },
          navigation: {
            enabled: true,
          },
        },
      },
    });

    // Pour les éléments de navigation et de pagination, on stop propagation des événements de clic
    this.querySelectorAll(".swiper-button-next, .swiper-button-prev, .swiper-pagination").forEach((element) => {
      element.addEventListener("click", (e) => {
        e.stopPropagation();
      });
    });
  }
}
customElements.define("product-card-swiper", ProductCardSwiper);

// Products list swiper
class Slideshow extends HTMLElement {
  constructor() {
    super();
    this.nbPerSlide = this.dataset.nbPerSlide ? this.dataset.nbPerSlide : 1;
    this.navigation = this.dataset.navigation ? this.dataset.navigation : false;
    this.pagination = this.dataset.pagination ? this.dataset.pagination : false;
    this.stepBetweenSlides = this.dataset.stepBetweenSlides ? this.dataset.stepBetweenSlides : 1;
    this.spaceBetween = this.dataset.spaceBetween ? this.dataset.spaceBetween : 16;
  }

  connectedCallback() {
    this.initializeSlideshow();
  }

  initializeSlideshow() {
    new Swiper(this.querySelector(".swiper"), {
      slidesPerView: this.nbPerSlide,
      slidesPerGroup: this.stepBetweenSlides,
      spaceBetween: this.spaceBetween,

      navigation: {
        nextEl: this.querySelector(".swiper-button-next.slideshow_button_next"),
        prevEl: this.querySelector(".swiper-button-prev.slideshow_button_prev"),
        enabled: this.navigation,
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
        enabled: this.pagination,
      },
    });
  }
}
customElements.define("slide-show", Slideshow);

// Instagram swiper
class InstagramSwiper extends HTMLElement {
  constructor() {
    super();
    this.autoplay = this.dataset.autoplay === 'true';
    this.autoplayDelay = parseInt(this.dataset.autoplayDelay) || 3;
    this.slidesPerView = parseInt(this.dataset.slidesPerView) || 4;
    this.spaceBetween = parseInt(this.dataset.spaceBetween) || 24;
  }

  connectedCallback() {
    this.initializeSwiper();
  }

  initializeSwiper() {
    const swiperConfig = {
      slidesPerView: 'auto',
      spaceBetween: this.spaceBetween,
      loop: true,
      loopAdditionalSlides: 2,
      navigation: {
        nextEl: this.querySelector(".instagram__button-next"),
        prevEl: this.querySelector(".instagram__button-prev"),
        enabled: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 24,
        },
        480: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        750: {
          slidesPerView: this.slidesPerView,
          spaceBetween: this.spaceBetween,
        },
      },
    };

    // Ajouter l'autoplay si activé
    if (this.autoplay) {
      swiperConfig.autoplay = {
        delay: this.autoplayDelay * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    new Swiper(this.querySelector(".swiper"), swiperConfig);

    // Empêcher la propagation des clics sur les contrôles
    this.querySelectorAll(".instagram__button-next, .instagram__button-prev").forEach((element) => {
      element.addEventListener("click", (e) => {
        e.stopPropagation();
      });
    });
  }
}
customElements.define("instagram-swiper", InstagramSwiper);

// Custom video player
class CustomVideoPlayer extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector("video");
    this.playButton = this.querySelector(".custom_video_play");
    this.pauseButton = this.querySelector(".custom_video_pause");
    this.controls = this.querySelector(".custom_controls");
  }

  connectedCallback() {
    this.addEventListener("click", this.handlePlayPause.bind(this));
  }

  handlePlayPause(event) {
    event.preventDefault();
    if (this.getAttribute("data-playing") === "true") {
      this.video.pause();
      this.setAttribute("data-playing", "false");
    } else {
      this.video.play();
      this.setAttribute("data-playing", "true");
    }
  }
}

customElements.define("custom-video-player", CustomVideoPlayer);
